import React from "react";
import { Scales } from "@phosphor-icons/react";

export function Logo({ variant = "light", size = "md" }) {
  const isDark = variant === "dark"; // dark background -> light text
  const scale = size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-2xl";
  const iconSize = size === "lg" ? 30 : size === "sm" ? 18 : 24;
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="app-logo">
      <span
        className="flex items-center justify-center rounded-md"
        style={{
          background: isDark ? "rgba(180,146,44,0.14)" : "#0A1128",
          padding: size === "lg" ? 8 : 6,
        }}
      >
        <Scales size={iconSize} weight="fill" color={isDark ? "#D4AF37" : "#D4AF37"} />
      </span>
      <span className={`font-display font-bold tracking-tight ${scale}`}>
        <span style={{ color: isDark ? "#FFFFFF" : "#0A1128" }}>LEX</span>
        <span style={{ color: "#B4922C" }}>ADM</span>
      </span>
    </div>
  );
}
